import { createAudioController, type AudioBackend } from './audio-controller'

interface PlaySoundOptions {
  /** For testing - inject mock backend */
  createBackend?: () => AudioBackend
}

interface PlaySoundResult {
  stop: () => void
  done: Promise<void>
}

export function playSound(
  url: string,
  options?: PlaySoundOptions,
): PlaySoundResult {
  const controller = createAudioController({
    createBackend: options?.createBackend,
  })

  let unsubscribe: (() => void) | null = null

  const done = new Promise<void>((resolve, reject) => {
    controller.setOnEnd(() => {
      unsubscribe?.()
      controller.dispose()
      resolve()
    })

    unsubscribe = controller.subscribe(() => {
      const state = controller.getSnapshot()
      if (state.state === 'error') {
        unsubscribe?.()
        controller.dispose()
        reject(new Error(state.error))
      }
    })
  })

  controller.load({ kind: 'url', url }, { autoplay: true })

  return {
    stop: () => {
      unsubscribe?.()
      controller.dispose()
    },
    done,
  }
}
